<template>
  <header class="heads" :class="menuopen ? 'open' : ''">
    <div class="w1440 cf relative">
      <div class="logo" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''"><router-link to="/"><img :src="globalDataArray.siteInfo.logoHead" alt=""></router-link></div>

      <div class="mainMenuMask"></div>
      <div class="mobileMenu" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
        <div class="searchLanLogin">
          <div class="cf">
            <div class="fl">
              <div class="searchArea">
                <div class="btn"><router-link to="/search" /></div>
              </div>
            </div>
            <div class="fl">
              <div class="switchLan fl">
                <a-select v-model="curLang" @change="switchLangFun" style="width: 69px;">
                  <a-select-option v-for="item in globalDataArray.siteLanguage" :key="item.value">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div v-if="islogin" class="myMsgBtn fl" @click="toMymsgFun"> <span v-if="msgnum && msgnum>0">{{ msgnum }}</span> </div>

            <div class="fl logoutBtn">
              <a-dropdown v-if="islogin">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  {{ curUserName }} <a-icon type="down" />
                </a>
                <a-menu slot="overlay" @click="loginoutFun">
                  <a-menu-item key="1">{{ globalDataArray.siteTemplateLanguage.person_user_center }}</a-menu-item>
                  <a-menu-item key="2">{{ globalDataArray.siteTemplateLanguage.login_out }}</a-menu-item>
                </a-menu>
              </a-dropdown>

              <div v-else class="loginBtn fnt_16" @click="handleLogin">{{ globalDataArray.siteTemplateLanguage.btn_login_register }}</div>
            </div>
          </div>
        </div>

        <!-- 文章目录区域 - 只在移动端且有文章树数据时显示 -->
        <div v-if="showArticleMenu" class="article-menu-section">
          <div class="menu-divider"></div>
          <div class="menu-section-title">文章目录</div>
          <div class="article-menu-container">
            <a-menu
              mode="inline"
              :selected-keys="selectedKeys"
              :open-keys="openKeys"
              @openChange="handleOpenChange"
              @select="handleMenuSelect"
              :style="{ borderRight: 0, background: 'transparent' }"
            >
              <template v-for="item in articleTree">
                <a-sub-menu v-if="item.children && item.children.length" :key="item.id">
                  <template #title>{{ item.title }}</template>
                  <template v-for="child in item.children">
                    <a-sub-menu v-if="child.children && child.children.length" :key="child.id">
                      <template #title>{{ child.title }}</template>
                      <template v-for="grandchild in child.children">
                        <a-sub-menu v-if="grandchild.children && grandchild.children.length" :key="grandchild.id">
                          <template #title>{{ grandchild.title }}</template>
                          <a-menu-item
                            v-for="greatGrandchild in grandchild.children"
                            :key="greatGrandchild.id"
                            @click="handleArticleClick(greatGrandchild)"
                          >
                            {{ greatGrandchild.title }}
                          </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item
                          v-else
                          :key="grandchild.id"
                          @click="handleArticleClick(grandchild)"
                        >
                          {{ grandchild.title }}
                        </a-menu-item>
                      </template>
                    </a-sub-menu>
                    <a-menu-item
                      v-else
                      :key="child.id"
                      @click="handleArticleClick(child)"
                    >
                      {{ child.title }}
                    </a-menu-item>
                  </template>
                </a-sub-menu>
                <a-menu-item
                  v-else
                  :key="item.id"
                  @click="handleArticleClick(item)"
                >
                  {{ item.title }}
                </a-menu-item>
              </template>
            </a-menu>
          </div>
        </div>

        <!-- 注释掉章节导航区域，已移到页面内容区域 -->
        <!--
        <div v-if="showSectionMenu" class="section-menu-section">
          <div class="menu-divider"></div>
          <div class="menu-section-title">本页总览</div>
          <div class="section-menu-container">
            <div
              v-for="heading in headings"
              :key="heading.id"
              class="section-item"
              :class="`level-${heading.level}`"
              @click="handleSectionClick(heading)"
            >
              <span class="section-prefix">{{ getSectionPrefix(heading.level) }}</span>
              <span class="section-text">{{ heading.title }}</span>
            </div>
          </div>
        </div>
        -->
      </div>
      <div class="mobileMenuBtn" @click="mianMenuFun"></div>
    </div>

    <!-- 老用户确认服务协议 -->
    <olduserxieyi :olduserxieyi.sync="olduserxieyi" @itemclick="olduserxieyiCallback" />
  </header>
</template>

<script>
import Cookies from 'js-cookie'
import { message } from 'ant-design-vue'
import { login, loginout } from '@/api/login/login'
export default {
  name: 'Heads',
  props: {
    // 接收文章树数据
    articleTree: {
      type: Array,
      default: () => []
    },
    // 接收当前文章信息
    currentArticle: {
      type: Object,
      default: () => null
    },
    // 接收章节标题数据
    headings: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isSelect: '/home',
      menuopen: false,
      islogin: false,
      curLang: '',
      curUserName: '',
      olduserxieyi: false, // 老用户协议
      selectedKeys: [],
      openKeys: [],
      isMobile: false // 添加移动端状态
    }
  },
  watch: {
    $route(to, from) {
      if (this.menuopen) {
        // 监听路由变化关闭弹层
        this.menuopen = false
      }
    },
    // 监听当前文章变化，更新菜单选中状态
    currentArticle: {
      immediate: true,
      handler(article) {
        if (article) {
          this.selectedKeys = [article.id]
        }
      }
    }
  },
  computed: {
    msgnum() {
      return this.$store.state.msgnum
    },
    // 计算是否显示文章菜单（只在移动端且有文章树数据时显示）
    showArticleMenu() {
      // 只在移动端且有文章树数据时显示
      return this.isMobile && this.articleTree && this.articleTree.length > 0
    }
  },
  created() {
    const that = this
    const atomUser = Cookies.get('atom_user')// 获取atom的cookie值
    const saiti_access_info = Cookies.get('saiti_access_info')
    that.checkLogin()
  },

  mounted() {
    const that = this
    that.isSelect = that.$route.path

    const currentLanguge = Cookies.get('DEFAULT_LANG')
    if (currentLanguge != null && currentLanguge != undefined && currentLanguge != '') {
      that.curLang = currentLanguge
    } else {
      that.curLang = that.globalDataArray.siteLanguage[0].value
    }

    // 初始化移动端状态和添加窗口大小变化监听
    if (!this.$isServer) {
      this.updateMobileStatus()
      window.addEventListener('resize', this.handleResize)
    }
  },

  beforeUnmount() {
    if (!this.$isServer) {
      window.removeEventListener('resize', this.handleResize)
    }
  },

  methods: {

    mianMenuFun() {
      const that = this
      that.menuopen = !that.menuopen
    },

    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.atomgit.com', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },

    checkLogin() {
      const that = this
      login({}).then(res => {
        if (res.success) {
          const result = JSON.stringify(res.result)
          Cookies.set('saiti_access_info', result, { domain: process.env.NODE_ENV === 'production' ? '.atomgit.com' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
          that.islogin = true

          if (res.result.nickname != '' && res.result.nickname != null && res.result.nickname != undefined) {
            that.curUserName = res.result.nickname
          } else {
            that.curUserName = res.result.username
          }
          this.$store.commit('setSiteMsgnum', res.result.noReadMsg)
          this.olduserxieyiFun()
        } else {
          const saiti_access_info = Cookies.get('saiti_access_info')
          if (saiti_access_info != null && saiti_access_info != undefined && saiti_access_info != '') {
            Cookies.remove('saiti_access_info', { domain: process.env.NODE_ENV === 'production' ? '.atomgit.com' : undefined, path: '/' })
            that.islogin = false
          }
        }
      })
    },
    switchLangFun(e) {
      const that = this
      const curlang = e
      const sitelang = that.globalDataArray.siteInfo.identification
      Cookies.set('DEFAULT_LANG', curlang, { domain: process.env.NODE_ENV === 'production' ? '.atomgit.com' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
      Cookies.set('attr_lang', sitelang, { domain: process.env.NODE_ENV === 'production' ? '.atomgit.com' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
      // Cookies.set('DEFAULT_LANG', curlang, { domain: '.atomgit.com', expires: 180, path: '/', secure: false })
      // Cookies.set('attr_lang', sitelang, { domain: '.atomgit.com', expires: 180, path: '/', secure: false })
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      }, 100)
    },

    loginoutFun(e) {
      const that = this
      if (e.key == '2') {
        const curmeta = that.$router.currentRoute.meta
        loginout({}).then(res => {
          if (res.success) {
            Cookies.remove('saiti_access_info', { domain: process.env.NODE_ENV === 'production' ? '.atomgit.com' : undefined, path: '/' })
            that.islogin = false

            const logoutUrl = that.logoutApiUrl + '?redirect_uri=' + encodeURIComponent(location.href)
            location.href = logoutUrl
          } else {
            message.error(res.message)
          }
        })
      } else {
        that.$router.push({ path: '/mypersonal' })
      }
    },

    moreChange(e) {
      this.$router.push({ path: e.key })
    },

    toMymsgFun() {
      this.$router.push({ path: '/mymessage' })
    },

    olduserxieyiFun() {
      let token = ''
      let info = {}
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
        info = JSON.parse(saitiAccessInfo)

        if (token != '' && token != undefined && info.isAgree == 0 && info.isAgree != null) {
          this.olduserxieyi = true
        }
      }
    },
    olduserxieyiCallback(res) {
      // console.log(res)
    },

    handleOpenChange(keys) {
      this.openKeys = keys
    },

    handleMenuSelect(key) {
      this.selectedKeys = [key]
    },

    handleArticleClick(item) {
      // 处理文章点击事件
      // 只有非目录项才跳转
      if (item.isDirectory === 0) {
        // 向父组件发送文章点击事件
        this.$emit('article-click', item)

        // 关闭移动端菜单
        this.menuopen = false
      } else {
        // 如果是目录节点，只切换展开状态
        const index = this.openKeys.indexOf(item.id)
        if (index === -1) {
          this.openKeys = [...this.openKeys, item.id]
        } else {
          const newOpenKeys = [...this.openKeys]
          newOpenKeys.splice(index, 1)
          this.openKeys = newOpenKeys
        }
      }
    },

    // 处理窗口大小变化，强制重新计算响应式属性
    handleResize() {
      // 更新移动端状态
      this.updateMobileStatus()
    },

    updateMobileStatus() {
      this.isMobile = window.innerWidth <= 1024
    }
  }
}
</script>
<style scoped>
/* 专门为articleHeader设计的样式，确保去掉mainMenu后布局正确 */
.w1440 {
  width: 96%;
}

.heads {
  min-height: 60px; /* 确保头部有足够的高度 */
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.heads .w1440 {
  min-height: 60px; /* 确保容器有足够的高度 */
}

.heads .logo {
  top: 50%; /* 垂直居中logo */
  transform: translateY(-50%);
  height: 68%; /* 大屏幕最大高度 */
}

.heads .searchLanLogin {
  /* 确保右侧区域正确定位 */
  line-height: 1;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}

/* 平板和中等屏幕 */
@media only screen and (max-width: 1440px) {
  .heads .logo {
    height: 65%;
  }
}

@media only screen and (max-width: 1200px) {
  .heads .logo {
    height: 62%;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 1024px) {
  .heads {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999999;
  }

  .heads > .w1440 {
    height: 50px;
    min-height: 50px;
  }

  .heads .logo {
    height: 32px;
    top: 50%;
    margin-top: -16px;
    transform: none;
    height: 58%;
  }

  .heads .searchLanLogin {
    position: static;
    transform: translateY(0);
    -webkit-transform: translateY(0);
  }

  /* 调整移动端菜单层级，确保不会过度遮挡 */
  .heads .mainMenuMask {
    z-index: 999998 !important;
  }

  .heads .mobileMenu {
    z-index: 999999 !important;
    max-height: 100vh;
    overflow-y: auto;
  }

  .heads .mobileMenuBtn {
    z-index: 1000000 !important;
  }

  .heads .article-menu-section {
    padding: 0 1em;
    border-top: 1px solid #e8e8e8;
    margin-top: 1em;
    padding-top: 1em;
  }

  .heads .article-menu-container {
    max-height: 40vh;
    overflow-y: auto;
  }

  .heads .article-menu-container :deep(.ant-menu-item) {
    padding-left: 16px !important;
    font-size: 14px;
    line-height: 36px;
    height: 36px;
  }

  .heads .article-menu-container :deep(.ant-menu-submenu-title) {
    padding-left: 16px !important;
    font-size: 14px;
    line-height: 36px;
    height: 36px;
  }

  .heads .article-menu-container :deep(.ant-menu-sub .ant-menu-item) {
    padding-left: 32px !important;
  }

  .heads .article-menu-container :deep(.ant-menu-sub .ant-menu-sub .ant-menu-item) {
    padding-left: 48px !important;
  }

  .heads .article-menu-container :deep(.ant-menu-sub .ant-menu-sub .ant-menu-sub .ant-menu-item) {
    padding-left: 64px !important;
  }

  /* 确保文章目录菜单项可点击 */
  .heads .article-menu-container :deep(.ant-menu-item:hover) {
    background-color: #f5f5f5;
  }

  .heads .article-menu-container :deep(.ant-menu-item-selected) {
    background-color: #e6f7ff;
    color: #1890ff;
  }
}

@media only screen and (max-width: 768px) {
  .heads .logo {
    height: 55%;
  }
}

@media only screen and (max-width: 480px) {
  .heads .logo {
    height: 50%;
  }
}

/* 文章目录区域样式 */
.article-menu-section {
  margin-top: 1em;
}

.menu-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 1em 0;
}

.menu-section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 1em;
  text-align: center;
  padding: 0.5em 0;
  background: #f8f9fa;
  border-radius: 4px;
}

.article-menu-container {
  max-height: 60vh;
  overflow-y: auto;
}

/* 自定义滚动条样式 */
.article-menu-container::-webkit-scrollbar {
  width: 4px;
}

.article-menu-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.article-menu-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.article-menu-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 章节导航区域样式 */
.section-menu-section {
  margin-top: 1em;
}

.section-menu-container {
  max-height: 60vh;
  overflow-y: auto;
}

/* 自定义滚动条样式 */
.section-menu-container::-webkit-scrollbar {
  width: 4px;
}

.section-menu-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.section-menu-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.section-menu-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 章节导航项样式 */
.section-item {
  padding: 0.75em 1em;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
  border-bottom: 1px solid #f0f0f0;
}

.section-item:hover {
  background-color: #f5f5f5;
}

.section-item:last-child {
  border-bottom: none;
}

.section-prefix {
  color: #999;
  font-size: 12px;
  min-width: 20px;
  margin-right: 8px;
}

.section-text {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.level-1 {
  font-weight: 500;
}

.level-1 .section-text {
  color: #333;
  font-weight: 500;
}

.level-2 {
  padding-left: 1.5em;
}

.level-2 .section-text {
  color: #555;
}

.level-3 {
  padding-left: 2em;
}

.level-3 .section-text {
  color: #666;
  font-size: 13px;
}

.level-4,
.level-5,
.level-6 {
  padding-left: 2.5em;
}

.level-4 .section-text,
.level-5 .section-text,
.level-6 .section-text {
  color: #999;
  font-size: 12px;
}
</style>
